import { ToastContent } from 'models/toasts';
import { actionTypes } from './action-types';

export const toastActions = {
  // トースト表示するエラーを追加
  appendToasts: (payload: ToastContent[]) => ({
    type: actionTypes.APPEND_TOASTS,
    payload,
  }),
  // 指定したトーストを削除
  removeToast: (payload: string) => ({
    type: actionTypes.REMOVE_TOAST,
    payload,
  }),
  // すべてのトーストを削除
  clearToasts: () => ({ type: actionTypes.CLEAR_TOASTS }),
};

type Actions = typeof toastActions;
export type ToastActions = ReturnType<Actions[keyof Actions]>;
